module.exports = __webpack_public_path__ + "static/img/attard-jack.8e0b9a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/attard-jack.jpg
// module id = N2Ra
// module chunks = 0